import type { ApiEventId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { ApiRsvp } from './types/ApiRsvpResponse';

type ApiResponse = {
  rsvps: ApiRsvp[];
};

function mapResponse(response: ApiResponse) {
  return response.rsvps;
}

const endpoint = new FetchEndpoint({
  urlFactory: (eventId: ApiEventId) => `/data/website/events/${eventId}/rsvps`,
  mapResponse,
});

// Exports

export const listingApiFetchRsvps = endpoint.createClientFetchFn();

export const listingApiIsomorphicFetchRsvps =
  endpoint.createIsomorphicFetchFn();
